import React,{Component} from 'react'
import { Player, ControlBar, ReplayControl,BigPlayButton,PosterImage,
    LoadingSpinner,track } from 'video-react';
    import 'video-react/dist/video-react.css';
    import $ from 'jquery';
    import { MDBAnimation } from "mdbreact";
     
   // this.ref.player.addTextTrack("My video text goes here")    
const VideoDetail = ({video,user}) => {
    let textVideo = React.createRef();
   // console.log(textVideo);
    if(!video){
        return <div> Loading..</div>
    }
    
    const videoSrc=`${video.url}`;
    return (
        <div className="ui grid">

        <div class="sixteen wide column">
        <Player over zoom src={videoSrc} ReplayControl encrypted
      currentTime     
      mute
      playsInline
    autoPlay="false"
    volume='true'     
 poster={videoSrc.urlCover} 
 onload="disableContextMenu();" onMyLoad="disableContextMenu();"
   / >
   
        </div>
  <div class="six wide column">
  <h4 className="ui header"><small style={{margin:'8px'}}>Now watching...</small><span style={{textShadow:'2px 2px 2px white'}}>{video.title}</span></h4>            
           <img class="ui top aligned tiny image" src={video.urlCover} alt='no image'/> 
         
         
                
  </div>   
        
        </div>
    )
}


export default VideoDetail